module.exports = __webpack_public_path__ + "static/media/icon-day-of-week.e53911af.svg";